<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 赋码管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>已关闭订单查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="100px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="订单" prop="qrcode_orderno">
                <el-input v-model="searchform.qrcode_orderno" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="供应商编码" prop="supplier_id">
                <el-input v-model="searchform.supplier_id" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="类型" prop="qrcode_order_type">
                <el-select
                  v-model="searchform.qrcode_order_type"
                  style="width:100%"
                  placeholder="请选择数据类型"
                >
                  <el-option
                    v-for="item in qrcode_order_type"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" >
              <el-form-item label="创建时间" prop="createtime">
                <el-date-picker
                  style="width:100%"
                  v-model="searchform.createtime"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" :offset="1">
              <el-button type="primary" icon="el-icon-search" @click="search" v-permission="['queryclose_select']">搜索</el-button>
              <el-button @click="resetForm('searchform')">重置</el-button>
        <el-button
        v-permission="['queryclose_export']"
          :loading="downloadLoading"
          type="primary"
          icon="document"
          @click="handleDownload"
        >导出Excel</el-button>
            </el-col>
          </el-row>
          <br>
        </el-form>
      </div>
      <el-divider></el-divider>
      <el-row type="flex" class="row-bg">
        <el-col :span="24">
          <el-table
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            border
            style="width:90%"
          >
            <el-table-column prop="id" label="编码"></el-table-column>
            <el-table-column prop="qrcode_order_type_name" label="类型"></el-table-column>
            <el-table-column prop="qrcode_orderno" label="订单" min-width="120"></el-table-column>
            <el-table-column prop="supplier" label="供应商"  min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode_quantity" label="生码数量"></el-table-column>
            <el-table-column prop="qrcode_status_name" label="生码状态"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" min-width="140"></el-table-column>
            <el-table-column prop="close_time" label="关闭时间" min-width="140"></el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[20,30,40,50,100]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
          <el-divider></el-divider>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  neworderno,
  readycreatebuild,
  getcodefilepath,
  getunbuildorders,
  getcodefile,
  queryclose,
  readycreateupdate,
  rulenewsquery,
  readycreateadd,
  readycreatedelete,
  updateclose
} from "@/api/tagging";
//引入导出组件模块
import FilenameOption from "@/views/excel/components/FilenameOption";
import AutoWidthOption from "@/views/excel/components/FilenameOption";
import BookTypeOption from "@/views/excel/components/FilenameOption";
export default {
  name: "ExportExcel",
  components: { FilenameOption, AutoWidthOption, BookTypeOption },
  mounted() {
    //请求部门列表数据并且便利到表格
    this.Tabledata();
    //请求下拉菜单数据 部门菜单
  },
  data() {
    return {
      //导出表格变量
        tableDataDownload:[],
      listLoading: true,
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //基础数据
      openIsDisabled: false,
      listLoading: false,
      dialogVisible: false,
      editVisible: false,
      account_status: [],
      role_uuid: [],
      tableData: [],
      //下拉菜单
      qrcode_order_type: [
        {
          key: 0,
          label: "手工新建"
        },
        {
          key: 1,
          label: "接口推送"
        }
      ],
      qrcode_status: [
        {
          key: 0,
          label: "未生码"
        },
        {
          key: 1,
          label: "生码中"
        }
      ],

      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      qrcode_order_type: [
        {
          key: 0,
          label: "手工创建"
        },
        {
          key: 1,
          label: "接口推送"
        }
      ],
      searchform: {
        product_code: "",
        qrcode_orderno: "",
        qrcode_status: null,
        qrcode_order_type: null,
        createtime: "",
        supplier_id: "",
        page_index:1,
        page_size:20,
      },
    };
  },
  methods: {
    //请求表格数据
    //拼接包材供应商id+name
    tablefor() {
      const len = this.tableData.length;
      for (let i = 0; i < len; i++) {
        this.tableData[i].create_time = this.tableData[i].create_time.replace(
          /T/,
          " "
        );
        this.tableData[i].update_time = this.tableData[i].update_time.replace(
          /T/,
          " "
        );
        this.tableData[i].close_time = this.tableData[i].close_time.replace(
          /T/,
          " "
        );
        if (this.tableData[i].supplier_name !== null) {
          this.tableData[i].supplier =
            this.tableData[i].supplier_id + this.tableData[i].supplier_name;
        } else {
          this.tableData[i].supplier = this.tableData[i].supplier_id;
        }
      }
    },
    //请求表格数据
    Tabledata(obj) {
      queryclose(obj).then(response => {
        this.tableData = response.data.data;
        this.tablefor();
        this.total_count = response.data.total_count;
        console.log(response.data);
        console.log(this.$store.state)
      });
    },
    //搜索事件
    search() {
      this.Tabledata({ 
        page_size:this.searchform.page_size,
        supplier_id: this.searchform.supplier_id,
        create_start_time: this.searchform.createtime==null ? null:this.searchform.createtime[0],
        create_end_time: this.searchform.createtime==null ? null:this.searchform.createtime[1],
        product_code: this.searchform.product_code,
        qrcode_orderno: this.searchform.qrcode_orderno,
        qrcode_order_type: this.searchform.qrcode_order_type,
        qrcode_status: this.searchform.qrcode_status
      })
    },
        //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
     //分页跳转事件
    currentchange(page_index) {
      this.searchform.page_index = page_index
     this.Tabledata({
        page_index:this.searchform.page_index,
        page_size:this.searchform.page_size,
        supplier_id: this.searchform.supplier_id,
        create_start_time: this.searchform.createtime==null ? null:this.searchform.createtime[0],
        create_end_time: this.searchform.createtime==null ? null:this.searchform.createtime[1],
        product_code: this.searchform.product_code,
        qrcode_orderno: this.searchform.qrcode_orderno,
        qrcode_order_type: this.searchform.qrcode_order_type,
        qrcode_status: this.searchform.qrcode_status
      })
    },
    //分页每页显示条数事件
    pagesize(page_size) {
     this.searchform.page_size = page_size
      this.search()
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index:this.searchform.page_index,
        page_size:this.total_count,
        supplier_id: this.searchform.supplier_id,
        create_start_time: this.searchform.createtime==null ? null:this.searchform.createtime[0],
        create_end_time: this.searchform.createtime==null ? null:this.searchform.createtime[1],
        product_code: this.searchform.product_code,
        qrcode_orderno: this.searchform.qrcode_orderno,
        qrcode_order_type: this.searchform.qrcode_order_type,
        qrcode_status: this.searchform.qrcode_status
      };
     queryclose(obj).then(response => {
        this.tableDataDownload = response.data.data;
      const len = this.tableData.length;
      for (let i = 0; i < len; i++) {
        this.tableDataDownload[i].create_time = this.tableDataDownload[i].create_time.replace(
          /T/,
          " "
        );
        this.tableDataDownload[i].update_time = this.tableDataDownload[i].update_time.replace(
          /T/,
          " "
        );
        this.tableDataDownload[i].close_time = this.tableDataDownload[i].close_time.replace(
          /T/,
          " "
        );
        if (this.tableDataDownload[i].supplier_name !== null) {
          this.tableDataDownload[i].supplier =
            this.tableDataDownload[i].supplier_id + this.tableDataDownload[i].supplier_name;
        } else {
          this.tableDataDownload[i].supplier = this.tableDataDownload[i].supplier_id;
        }
      }
        console.log(this.tableDataDownload);
      import("@/vendor/Export2Excel").then(excel => {
        const tHeader = [
          "编码",
          "类型",
          "订单",
          "供应商",
          "生码数量",
          "生码状态",
          "创建时间",
          "关闭时间"
        ];
        const filterVal = [
          "id",
          "qrcode_order_type_name",
          "qrcode_orderno",
          "supplier",
          "qrcode_quantity",
          "qrcode_status_name",
          "create_time",
          "close_time"
        ];
        const list = this.tableDataDownload;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        });
        this.downloadLoading = false;
      });
      }); // hear

    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    }
  }
};
</script>
<style scoped>
</style>
